

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */

import 'datatables.net-dt';
import 'bootstrap';

import purl from '@allmarkedup/purl/purl';
import $ from 'jquery';

import {
    BundleParser, DocumentUtil, LazyOnScreenThumbnailLoader,
} from '../js/document';
import { createLocalization, getTranslator, setupLocaleSwitcher } from '../js/i18n';
import tools from '../js/tools';
import signatureHandlers from './signature_handlers';
import utils from './utils';

const { LogEventType, secureLog } = tools;

const t = getTranslator();

export function metadataToObject(metadata) {
    const metadataObj = {};
    for(const obj of metadata) {
        metadataObj[obj.name] = obj.value;
    }
    return metadataObj;
}

export const globals = {
    bundleId: null,
    logId: null,
    variables: null,
    wizvars: null,
    signatureClassType: null,
    formSignData: null,
    buttonArray: null,
    bundle: null,
    wasOpened: false,
    alreadySigned: false,
};


export function createSignatureAnchor(uid, documentId, cls, content) {
    const variables = globals.bundle[uid];
    const doclist_locations = variables.doclist_locations;
    if(doclist_locations.length == 1) {
        return `<a class="open-document ${cls}" data-uid="${tools.xmlescape(uid)}"
            data-docid="${documentId}" href="javascript:void(0);" role="button">
            ${content}
        </a>`;
    }

    let markup = '<ul class="dropdown-menu">';
    for(let i = 0; i < doclist_locations.length; i++) {
        markup += `<li><a class="open-document" data-uid="${tools.xmlescape(uid)}"
            data-signindex="${i}" data-i18n="wizard.sign_number"
            data-i18n-options='{"n":${i + 1}}'
            href="javascript:void(0);">${t('wizard.sign_number', { n: i + 1 })}</a></li>`;
    }
    markup += '</ul>';

    return `<div class="btn-group">
        <a class="dropdown-toggle ${cls}"
            data-toggle="dropdown" haspopup="true" aria-expanded="false"
            data-docid="${documentId}" href="javascript:void(0);" role="button">
            ${content}
        </a>
        ${markup}
    </div>`;
}


export function renderThumbnail(cell, cellData, rowData, rowIndex, colIndex) {
    const row = rowData;
    const documentId = tools.xmlescape(globals.bundleId + ':' + row.bundleIndex);

    let html = `<div class="thumbnail-holder root-row">
    <img class="thumbnail-loader" width="48" height="48" src="images/thumbnail-gif.gif" alt="thumbnail">
</div>`;

    html = createSignatureAnchor(row.uid, documentId, 'document-thumbnail', html);
    const anchor = $(html).appendTo(cell);
    new LazyOnScreenThumbnailLoader(globals.bundle, anchor.find('img.thumbnail-loader')).startObserving();
}

export function renderThumbnailImage(cell, rowData, signAnchor) {
    const row = rowData;
    const uid = tools.xmlescape(row.uid);
    const documentId = tools.xmlescape(globals.bundleId + ':' + row.bundleIndex);

    let html = `<div class="thumbnail-holder root-row document-thumbnail" data-uid="${uid}" data-docid="${documentId}">
<img class="thumbnail-loader" width="48" height="48" src="images/thumbnail-gif.gif" alt="thumbnail">
</div>`;

    if(signAnchor) {
        html = `<a class="button-sign-single" data-index="${row.bundleIndex}" href="javascript:void(0);" role="button">
${html}
</a>`;
    }

    const image = $(html).appendTo(cell);
    new LazyOnScreenThumbnailLoader(globals.bundle, image.find('img.thumbnail-loader')).startObserving();
}

export function updateWizardState() {
    return Promise.resolve()
        .then(() => {
            if(!globals.bundleId)
                return Promise.reject(new Error('Document not selected!'));
            return tools.api('viewerui/verify.cmd', { document: globals.bundleId }, { errors: true, waiting: true, noalert: true });
        })
        .then((data) => {
            const bundleMeta = data.data;
            const variables = bundleMeta.variables;
            const profile = data.profile;
            const exdata = data.exdata;
            const bundleParser = new BundleParser(variables.bundle, variables.bundleOrder);
            const buttonArray = bundleParser.buttonArray;
            const doclistMetadata = metadataToObject(variables.doclist_metadata);
            globals.logId = (exdata && exdata.logId) || '';
            globals.buttonArray = buttonArray;
            globals.bundle = bundleParser.bundle;
            globals.variables = variables;
            globals.profile = profile;
            const alreadySigned = (variables.doclist_documentsCompleted == variables.doclist_documentsTotal);
            globals.alreadySigned = alreadySigned;

            if(alreadySigned && doclistMetadata.titleFinished) {
                $('#title').attr('data-i18n', '').text(doclistMetadata.titleFinished);
            } else if(doclistMetadata.title) {
                $('#title').attr('data-i18n', '').text(doclistMetadata.title);
            }
            let nameHeading = t('sign.name');
            let nameHeadingDefault = true;
            if(doclistMetadata.nameHeading) {
                nameHeading = doclistMetadata.nameHeading;
                nameHeadingDefault = false;
            }

            const haveFinishButton = alreadySigned && variables.goOnWizardSuccess;
            const haveCloseButton = !alreadySigned && variables.gobackOriginUrl;
            const protectedDocument = tools.authenticator.protectedDocument;
            const haveLogoutButton = protectedDocument && !(haveFinishButton || haveCloseButton);
            $('#finish,#vwr-fine').toggleClass('hidden', !haveFinishButton);
            $('#addsign').toggleClass('hidden', alreadySigned);
            $('#vwr-close').toggleClass('hidden', !haveCloseButton);
            $('#vwr-signout').toggleClass('hidden', !haveLogoutButton);

            return {
                profile,
                nameHeading,
                nameHeadingDefault,
                buttonArray,
            };
        });
}

const wizardListener = {
    _i18next: null,
    _i18nextEvents: null,
    i18next() {
        return {
            i18next: this._i18next,
            i18nextEvents: this._i18nextEvents,
        };
    },
    initData() {
    },
    selectRectArea(position, signarea, options) {
    },
    deselectRectArea(controls, cb) {
        cb && cb();
    },
    queueMoveToRect(position) {
    },
    moveToNextWizardPage() {
    },
    wizardPageLoaded(cb) {
        cb && cb();
    },
    documentChanged(page, cb) {
        cb && cb();
    },
    enableFinishWizard() {
    },
    finishWizard() {
    },
    finishWizardButtons() {
    },
    errorMessageHandler: tools.errutil.errorMessageHandler,
    waiting: tools.waiting.waiting,
    authenticator: tools.authenticator,
    showDialog(id, html) {
        let modal = $('#' + id);
        if(modal.length) {
            modal.modal('hide');
            modal.remove();
        }
        modal = $(html).appendTo($(document.body));
        modal.attr('id', id);
        modal.modal();
        modal.on('hidden', function() {
            modal.remove();
        });
        return modal;
    },
    confirm(message, cb) {
        tools.confirm(message, cb.bind(null, null));
    },
};

export class SignHandlerApi {
    constructor(documentId) {
        this.documentId = documentId;
    }
    dynamicAction(params, options, cb) {
        params.document = this.documentId;
        return tools.api('viewerui/doclisthandleraction.cmd', params, options, cb);
    }
    execApi(command, params, options, cb) {
        return tools.api('viewerui/' + command, params, options, cb);
    }
}

export class SignerBase {
    constructor(haveSignHandler) {
        this.signHandlerApi = new SignHandlerApi(globals.bundleId);
        this.signHandler = null;
        const formSignData = globals.formSignData;
        if(haveSignHandler && formSignData && formSignData.signHandlerType) {
            const SignHandlerClass = signatureHandlers[formSignData.signHandlerType];
            if(SignHandlerClass) {
                this.signHandler = new SignHandlerClass(wizardListener, this.signHandlerApi);
            }
        }
    }

    showSignDialog(autoSign, currentDocumentIndex) {
        if(globals.variables.doclist_documentsCompleted == globals.variables.doclist_documentsTotal) {
            tools.scripterr(new Error(t('wizard.already_signed')));
            return;
        }
        const self = this;
        let showModal = false;
        const haveAdditionalFields = SignerBase.initDialog(currentDocumentIndex !== undefined);
        $('#wizardForm').off('click').on('click', '[data-type="sign-action"]', function() {
            const button = $(this);
            const action = button.attr('data-action');
            self.executeSignatureAction(action, button.attr('data-params'))
                .then(() => {
                    $('#wizardForm')
                        .find(':input:visible[name]')
                        .not('[data-type="sign-action"]')
                        .not('[type="hidden"]')[0]?.focus();
                    if(action == 'sendCredential') {
                        tools.errutil.errorMessageHandler(t('auth.otp_delivery'), 'success', '', 2000);
                        return;
                    }
                    tools.errutil.errorMessageHandler(t('common.ok'), 'success');
                })
                .catch((err) => {
                    if(err && !err.no_show_error)
                        tools.scripterr(err);
                });
        });
        const performSign = () => {
            Promise.resolve()
                .then(() => this._sign(currentDocumentIndex))
                .then(() => {
                    if(showModal) {
                        $('#addsign-dialog').modal('hide');
                    }
                })
                .catch((err) => {
                    if(err && !err.no_show_error) {
                        if(/^SOAP service returned error:/i.test(err.message)) {
                            err.message = t('wizard.soap_error') + err.message.substring(err.message.indexOf(':'));
                        }
                        tools.scripterr(err);
                    }
                })
                .then(() => this._invalidate());
        };
        $('#wizardForm').off('submit').on('submit', (evt) => {
            evt.preventDefault();
            //we should exit here
            if(!$('#wizardForm').valid())
                return;
            performSign();
        });
        if(autoSign && !haveAdditionalFields) {
            // Roberto request - skip signature dialog and go straight to wizard (for interactive signatures)
            performSign();
        } else {
            showModal = true;
            $('#addsign-dialog').modal('show');
        }
    }

    _sign() {
        return Promise.resolve(this);
    }
    _invalidate() {
        return Promise.resolve(this);
    }

    prepareFormSignData() {
        return Promise.resolve()
            .then(() => {
                const additionalFields = {};
                $('#additional-controls').find('input').each(function() {
                    const input = $(this);
                    const name = input.attr('data-name');
                    const value = input.cleverVal({ string: true });
                    additionalFields[name] = value;
                });
                if(this.signHandler && this.signHandler.prepareFormSignData) {
                    return new Promise((resolve, reject) => {
                        this.signHandler.prepareFormSignData(additionalFields, function(err) {
                            if(err)
                                return reject(err);
                            return resolve(additionalFields);
                        });
                    });
                }
                return additionalFields;
            })
            .then((additionalFields) => {
                $('#FormSignData').val(JSON.stringify({ additionalFields }));
            });
    }

    executeSignatureAction(action, actionParams) {
        return Promise.resolve()
            .then(() => {
                if(this.signHandler) {
                    //check if we can handle action locally
                    return new Promise((resolve, reject) => {
                        this.signHandler.handleLocalAction(action, actionParams, function(err, handled) {
                            if(err)
                                return reject(err);
                                //this will break execution chain
                            if(handled)
                                return null;
                            return resolve();
                        });
                    });
                }
                return null;
            })
            .then(this.prepareFormSignData.bind(this))
            .then(() => {
                $('#SharedState').val('{}');
                //serialize doesn't write disabled controls
                const form = $('#wizardForm');
                const data = form.serializeArray();
                data.push({ name: 'signAction', value: action });
                data.push({ name: 'signActionParams', value: actionParams });
                data.push({ name: 'dynamic-action', value: 'sign-qualified-handler-action' });
                data.push({ name: 'document', value: globals.bundleId });
                //will return chainable deferred object
                return tools.api('viewerui/doclisthandleraction.cmd', $.param(data), { errors: true, waiting: true, noalert: true });
            });
    }

    static _makeError(text, no_show_error) {
        const err = new Error(text);
        if(no_show_error)
            err.no_show_error = no_show_error;
        return err;
    }
    static initDialog(singleDocument) {
        const variables = globals.variables;
        const signaturesLeft = (Number(variables.doclist_documentsTotal) - Number(variables.doclist_documentsCompleted));
        if(singleDocument) {
            $('#addsign-description')
                .attr('data-i18n', 'wizard.sign_document')
                .text(t('wizard.sign_document'));
        } else {
            $('#addsign-description')
                .attr('data-i18n', 'wizard.sign_documents')
                .attr('data-i18n-options', JSON.stringify({ count: signaturesLeft }))
                .text(t('wizard.sign_documents', { count: signaturesLeft }));
        }

        const rules = {};
        const formatter = new tools.SubstitutionProcessor(globals.wizvars, 'it-IT');
        const formSignData = globals.formSignData;
        const additionalFields = formSignData && formSignData.additionalFields;
        if(additionalFields && additionalFields.length) {
            const div = $('#additional-controls');
            div.empty();
            const template = {
                rowClass: 'form-group',
                controlClass: 'form-control',
                labelClass: '',
                buttonClass: 'btn btn-default',
            };
            for(let i = 0; i < additionalFields.length; i++) {
                const def = additionalFields[i];
                const input = utils.createControl(div, rules, def, template);
                input.cleverVal(formatter.process(def.value || ''));
            }
        }

        //recreate validator
        if(SignerBase._validator)
            SignerBase._validator.destroy();
        SignerBase._validator = utils.defaultValidator($('#wizardForm'), rules);
        return !!additionalFields?.length;
    }
}
SignerBase._validator = null;

function processCustomFinalizeUrl(anchor, event, logEvent) {
    const protectedDocument = tools.authenticator.protectedDocument;
    const bundleId = globals.bundleId;
    if(anchor.attr('data-logged-out'))
        return true;
    event?.preventDefault();
    event?.stopPropagation();
    Promise.resolve()
        .then(() => {
            if(!globals.alreadySigned)
                return tools.authenticator.confirmLogout();
            return undefined;
        })
        .then(() => {
            if(logEvent)
                return secureLog.notifyServer(bundleId, logEvent, undefined, { waiting: true, errors: true });
            return undefined;
        })
        .then(() => {
            //process exit event before logout, so logout dialog won't be shown
            if(globals.wasOpened) {
                globals.wasOpened = false;
                return secureLog.notifyServer(bundleId, LogEventType.closeList, undefined, { waiting: true, errors: true });
            }
            return undefined;
        })
        .then(() => {
            if(protectedDocument)
                return tools.authenticator.logout();
            return undefined;
        })
        .then(() => {
            anchor.attr('data-logged-out', 'true');
            anchor[0].click();
        })
        .catch((err) => { tools.scripterr(err); });
    return false;
}

function initUi() {
    const variables = globals.variables;

    if(variables.gobackOriginUrl || variables.goOnWizardSuccess) {
        const __variables = {
            ID: {
                value: encodeURIComponent(globals.bundleId),
                type: 'Text',
            },
            logID: {
                value: encodeURIComponent(globals.logId),
                type: 'Text',
            },
        };
        const formatter = new tools.SubstitutionProcessor(__variables);
        if(variables.gobackOriginUrl) {
            const url = formatter.process(variables.gobackOriginUrl);
            $('#vwr-close').attr('href', url);
            $('#vwr-close').attr('data-custom-href', 'true');
        }
        if(variables.goOnWizardSuccess) {
            const url = formatter.process(variables.goOnWizardSuccess);
            $('#finish,#vwr-fine').attr('href', url);
            $('#finish,#vwr-fine').attr('data-custom-href', 'true');
        }
        if(variables.urlTarget) {
            $('#vwr-close').attr('target', variables.urlTarget);
            $('#finish,#vwr-fine').attr('target', variables.urlTarget);
        }
    }

    $('#finish,#vwr-fine').on('click', function(evt) {
        const anchor = $(this);
        processCustomFinalizeUrl(anchor, evt, LogEventType.listConfirmPressed);
    });
    $('#vwr-close').on('click', function(evt) {
        const anchor = $(this);
        processCustomFinalizeUrl(anchor, evt, LogEventType.listClosePressed);
    });
    $('#vwr-signout').on('click', function(evt) {
        const anchor = $(this);
        const logoutCompleted = processCustomFinalizeUrl(anchor, evt);
        if(!logoutCompleted) {
            return;
        }
        window.location.href = APP_ROOT + 'logout.jsp';
    });
}

export function initWizard({ updateInteractiveStatus, signedDocumentIndex, skipLogEvent } = {}) {
    let wizardState;
    return Promise.resolve()
        .then(() => createLocalization())
        .then(({ i18next, i18nextEvents }) => {
            wizardListener._i18next = i18next;
            wizardListener._i18nextEvents = i18nextEvents;
            setupLocaleSwitcher();
        })
        .then(() => DocumentUtil.determineDocumentId(purl, tools.api.bind(tools, 'viewerui/documentbyotp.cmd')))
        .then((_docId) => {
            globals.bundleId = _docId;
            tools.authenticator.initialize(_docId, false);
            return tools.authenticator.precheck();
        })
        .then((userId) => {
            if(userId) {
                $('#loggedin-userid').find('span').text(userId.SignerName || userId.SignerFiscalCode || '');
                $('#loggedin-userid').removeClass('hidden');
            }
        })
        .then(() => {
            if(!skipLogEvent) {
                const params = {
                    url: window.location.href,
                };
                return secureLog.notifyServer(globals.bundleId, LogEventType.openList, params, { waiting: true, errors: true });
            }
            return undefined;
        })
        .then(() => {
            if(updateInteractiveStatus) {
                //nothing initialized here, no globals, just arguments
                //after update all values are updated, and we can query new data
                const documentId = globals.bundleId + ':' + signedDocumentIndex;
                const data = {
                    document: documentId,
                };
                return tools.api('viewerui/doclistinteractiveupdate.cmd', data, { errors: true, noalert: true, waiting: true });
            }
            return undefined;
        })
        .then(() => updateWizardState())
        .then((_wizardState) => {
            wizardState = _wizardState;
            return tools.api('viewerui/doclistrender.cmd', { document: globals.bundleId }, { errors: true, waiting: true, noalert: true });
        })
        .then((data) => {
            globals.wizvars = data.wizvars;
            globals.signatureClassType = data.signatureClassType;
            globals.formSignData = (typeof data.formSignData === 'string') ? JSON.parse(data.formSignData) : data.formSignData;
            globals.wasOpened = true;
        })
        .then(() => {
            initUi();
            return wizardState;
        });
}
